// src/components/PrivacyPolicy.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  const lastUpdated = 'January 14, 2025';
  const contactEmail = 'privacy@namecamper.com';

  return (
    <div className="privacy-policy">
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: {lastUpdated}</p>

        <section className="privacy-section">
          <h2>1. Introduction</h2>
          <p>
            NameCamper ("we," "our," or "us") is committed to protecting your privacy.
            This Privacy Policy explains how we collect, use, disclose, and safeguard your
            information when you use our username and domain monitoring service.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. Information We Collect</h2>

          <h3>2.1 Information You Provide</h3>
          <ul>
            <li><strong>Account Information:</strong> When you create an account, we collect your email address and name through our authentication provider (Clerk).</li>
            <li><strong>Monitoring Preferences:</strong> The usernames and domain names you choose to monitor.</li>
            <li><strong>Notification Settings:</strong> Your preferences for how and when you want to be notified.</li>
          </ul>

          <h3>2.2 Information Collected Automatically</h3>
          <ul>
            <li><strong>Usage Data:</strong> Information about how you interact with our service, including features used and actions taken.</li>
            <li><strong>Device Information:</strong> Browser type, operating system, and device identifiers.</li>
            <li><strong>Log Data:</strong> IP address, access times, and pages viewed.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and maintain our username and domain monitoring service</li>
            <li>Send you notifications when monitored names become available</li>
            <li>Process and manage your account</li>
            <li>Communicate with you about service updates and changes</li>
            <li>Improve and optimize our service</li>
            <li>Detect and prevent fraud or abuse</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>4. Information Sharing</h2>
          <p>We do not sell your personal information. We may share your information with:</p>
          <ul>
            <li><strong>Service Providers:</strong> Third-party companies that help us operate our service (authentication, email delivery, hosting).</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety.</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>5. Third-Party Services</h2>
          <p>Our service integrates with the following third-party services:</p>
          <ul>
            <li><strong>Clerk:</strong> For user authentication and account management</li>
            <li><strong>Resend:</strong> For sending email notifications</li>
            <li><strong>Cloudflare:</strong> For hosting and security</li>
          </ul>
          <p>Each of these services has their own privacy policies governing the use of your information.</p>
        </section>

        <section className="privacy-section">
          <h2>6. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your
            personal information against unauthorized access, alteration, disclosure, or
            destruction. However, no method of transmission over the Internet is 100% secure.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. Data Retention</h2>
          <p>
            We retain your personal information for as long as your account is active or as
            needed to provide you services. You can delete your account at any time, and we
            will delete your personal information within 30 days, unless we are required to
            retain it for legal purposes.
          </p>
        </section>

        <section className="privacy-section">
          <h2>8. Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Correct inaccurate personal information</li>
            <li>Delete your personal information</li>
            <li>Object to or restrict processing of your information</li>
            <li>Data portability</li>
            <li>Withdraw consent</li>
          </ul>
          <p>To exercise these rights, please contact us at {contactEmail}.</p>
        </section>

        <section className="privacy-section">
          <h2>9. Children's Privacy</h2>
          <p>
            Our service is not intended for children under 13 years of age. We do not
            knowingly collect personal information from children under 13.
          </p>
        </section>

        <section className="privacy-section">
          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any
            changes by posting the new Privacy Policy on this page and updating the "Last
            updated" date.
          </p>
        </section>

        <section className="privacy-section">
          <h2>11. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or our privacy practices,
            please contact us at:
          </p>
          <p className="contact-info">
            <strong>Email:</strong> {contactEmail}
          </p>
        </section>

        <div className="privacy-actions">
          <Link to="/" className="btn btn-primary">
            Back to Home
          </Link>
          <Link to="/terms" className="btn btn-secondary">
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
